import { render, staticRenderFns } from "./instance.vue?vue&type=template&id=23412ceb&scoped=true"
import script from "./instance.vue?vue&type=script&lang=js"
export * from "./instance.vue?vue&type=script&lang=js"
import style0 from "./instance.vue?vue&type=style&index=0&id=23412ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23412ceb",
  null
  
)

export default component.exports